// Module registry: one import per feature folder, in rail order. Adding a
// module = one folder + one line here (the integrator's job). Gating (flag,
// role, capability, mode) happens in gates.ts from each module's own
// declaration — this file never special-cases a module. The hotel folder
// exports its two rail entries (HANDOFF §17: «الغرف» first, «الحجوزات» in
// the place of «المواعيد» — declared on the module, applied by gates.ts).

import { hotelReservations, hotelRooms } from '@/features/hotel';
import today from '@/features/today';
import calendar from '@/features/calendar';
import booking from '@/features/booking';
import customers from '@/features/customers';
import accounts from '@/features/accounts';
import inventory from '@/features/inventory';
import team from '@/features/team';
import reports from '@/features/reports';
import tasks from '@/features/tasks';
import apps from '@/features/apps';
import settings from '@/features/settings';
import system from '@/features/system';
import type { ErpModule } from './module-types';

export const MODULES: readonly ErpModule[] = [hotelRooms, hotelReservations, today, calendar, booking, customers, accounts, inventory, team, reports, tasks, apps, settings, system];
